export const faqs = [
  {
    question: '看料社的「追踪」和普通资讯有什么不同？',
    answer:
      '普通资讯往往只报道一次，而追踪会把同一条线索按时间顺序持续记录。你可以在一篇专题里看到从最初的线索、相关回应，到后续进展的完整脉络，不需要再到多个平台拼凑版本。',
  },
  {
    question: '一条线索多久更新一次？',
    answer:
      '取决于事件本身是否有新进展。处于活跃期的线索通常会在有明确来源的更新后当天补录；进入平稳期的线索会降低频率，并在确认无后续时标记为已归档，页面仍会保留全部历史节点。',
  },
  {
    question: '页面上会出现未经核实的内容吗？',
    answer:
      '我们只收录有明确发布主体的信息，例如官方通稿、平台公告或当事人说明。对于仅有“知情人士”表述的内容，会在时间线中单独标注，并且不作为事实结论呈现。',
  },
  {
    question: '我可以提交线索或者补充后续吗？',
    answer:
      '可以。你可以通过页面底部的联系表单留言，附上你认为有价值的公开来源链接。编辑会先核对来源是否可追溯，再决定是否进入时间线，并在更新时标注补充节点。',
  },
  {
    question: '为什么要保留已归档的线索？',
    answer:
      '事件会过去，但记录本身有价值。归档并不代表删除，而是表示我们判断短期内不会再出现明确的新进展。保留节点可以让后来查证的人看到完整过程。',
  },
  {
    question: '追踪页面的热度数字代表什么？',
    answer:
      '热度是一个综合参考值，由页面访问、站内收藏与更新频率等维度加权得出，用于呈现某条线索当前的关注程度。它不代表对事件性质的判断。',
  },
];